module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_02-62cf1b28e33695f5019931d733576081.jpg";